const configs = {
  env: process.env.REACT_APP_ENV,
  baseURL: process.env.REACT_APP_API_BASE_URL,
  googleTMId: process.env.REACT_APP_GTM_ID,
};

export default configs;
